<template>
  <div class="filters-tags">
    <div v-if="has_filters" class="pr-1">Filtri attivi:</div>
    <div v-if="has_filters">
      <b-badge variant="cta" @click="remove_all_filters">elimina tutti</b-badge>
    </div>
    <div
      v-for="filter in shown_filters"
      :key="filter.key"
      @click="remove_filter(filter.key)"
    >
      <b-badge variant="info">{{ filter.label }}</b-badge>
    </div>
  </div>
</template>

<script>
import {
  get_active_filters,
  remove_filter,
  remove_all_filters,
} from "@liveflight/utilities/filters";

export default {
  name: "filters-tags",
  computed: {
    has_filters() {
      return this.shown_filters.length;
    },
    shown_filters() {
      return this.get_active_filters()
    },
  },
  methods: {
    get_active_filters,
    remove_filter,
    remove_all_filters,
  },
};
</script>

<style lang="scss">
.filters-tags {
  display: flex;
  flex-wrap: wrap;
  .badge {
    padding: $grid-gutter-width/6 $grid-gutter-width/4;
    border-radius: $border-radius-sm;
    margin-right: $grid-gutter-width/4;
    margin-bottom: $grid-gutter-width/4;
    text-transform: uppercase;
    cursor: pointer;
    transition: $transition-base;
    &:hover {
      opacity: 0.85;
    }
    &:after {
      display: inline-block;
      line-height: 70%;
      content: "\00d7";
      font-size: 14px;
      margin-left: 6px;
      @include font-primary-regular;
    }
  }
}
</style>
